var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemsPerPage = exports.defaultPage = exports.BaseLeaderboardController = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _reactI18next = require("react-i18next");
var itemsPerPage = exports.itemsPerPage = 10;
var defaultPage = exports.defaultPage = 1;
var BaseLeaderboardController = exports.BaseLeaderboardController = (0, _createClass2["default"])(function BaseLeaderboardController() {
  var _this = this;
  (0, _classCallCheck2["default"])(this, BaseLeaderboardController);
  (0, _defineProperty2["default"])(this, "_useData", function () {
    return {
      data: null,
      isLoading: false
    };
  });
  (0, _defineProperty2["default"])(this, "useController", function (_ref) {
    var _data$options2;
    var organizationId = _ref.organizationId,
      challengeId = _ref.challengeId,
      teamId = _ref.teamId,
      superGroupId = _ref.superGroupId;
    var _useTranslation = (0, _reactI18next.useTranslation)(),
      i18n = _useTranslation.i18n;
    var _useState = (0, _react.useState)(defaultPage),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];
    var _useState3 = (0, _react.useState)(undefined),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      sortBy = _useState4[0],
      setSortBy = _useState4[1];
    var _useState5 = (0, _react.useState)(undefined),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      filterBy = _useState6[0],
      setFilterBy = _useState6[1];
    var _this$_useData = _this._useData({
        organizationId: organizationId,
        teamId: teamId,
        superGroupId: superGroupId,
        locale: i18n.language,
        challengeId: challengeId,
        currentPage: currentPage,
        sortBy: sortBy
      }),
      data = _this$_useData.data,
      isLoading = _this$_useData.isLoading;
    var _filterByItems = (0, _react.useMemo)(function () {
      var _data$columns;
      return Array.from(new Set((data == null ? void 0 : (_data$columns = data.columns) == null ? void 0 : _data$columns.filter(function (item) {
        return !!item.filterable;
      }).map(function (item) {
        return JSON.stringify(item.filterable);
      })) || []), function (item) {
        return JSON.parse(item);
      });
    }, [data == null ? void 0 : data.columns]);
    var _onSelectFilter = (0, _react.useCallback)(function (id) {
      var _data$columns2, _column$sortable;
      setFilterBy(id);
      var column = data == null ? void 0 : (_data$columns2 = data.columns) == null ? void 0 : _data$columns2.find(function (item) {
        var _item$filterable;
        return ((_item$filterable = item.filterable) == null ? void 0 : _item$filterable.id) === id && item.sortable;
      });
      if (column != null && (_column$sortable = column.sortable) != null && _column$sortable.id) {
        setSortBy(column.sortable.id);
      }
    }, [data == null ? void 0 : data.columns]);
    var _selectedIdFilter = (0, _react.useMemo)(function () {
      var _filterByItems$;
      return filterBy || (_filterByItems == null ? void 0 : (_filterByItems$ = _filterByItems[0]) == null ? void 0 : _filterByItems$.id);
    }, [_filterByItems, filterBy]);
    var _sortByItems = (0, _react.useMemo)(function () {
      var _data$columns3;
      return Array.from(new Set((data == null ? void 0 : (_data$columns3 = data.columns) == null ? void 0 : _data$columns3.filter(function (item) {
        if (item.filterable) {
          var _item$filterable2;
          return !!item.sortable && ((_item$filterable2 = item.filterable) == null ? void 0 : _item$filterable2.id) === _selectedIdFilter;
        }
        return !!item.sortable;
      }).map(function (item) {
        return JSON.stringify(item.sortable);
      })) || []), function (item) {
        return JSON.parse(item);
      });
    }, [_selectedIdFilter, data == null ? void 0 : data.columns]);
    var _selectedIdSort = (0, _react.useMemo)(function () {
      var _data$options;
      return sortBy || (data == null ? void 0 : (_data$options = data.options) == null ? void 0 : _data$options.default_sort);
    }, [sortBy, data == null ? void 0 : (_data$options2 = data.options) == null ? void 0 : _data$options2.default_sort]);
    return {
      isLoading: isLoading,
      data: data,
      setCurrentPage: setCurrentPage,
      sort: {
        selectedId: _selectedIdSort,
        onSelect: setSortBy,
        items: _sortByItems
      },
      filter: {
        selectedId: _selectedIdFilter,
        onSelect: _onSelectFilter,
        items: _filterByItems
      }
    };
  });
});